import { render, staticRenderFns } from "./SkipEvent.vue?vue&type=template&id=5272bd24&"
import script from "./SkipEvent.vue?vue&type=script&lang=js&"
export * from "./SkipEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports